import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementEmailsIndexScene from 'scenes/management/emails'
import ManagementEmailsEditScene from 'scenes/management/emails/edit'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_SETTINGS_EMAILS]: {
		component: ManagementEmailsIndexScene,
	},
	[AppRoutes.MANAGEMENT_SETTINGS_EMAILS_EDIT]: {
		component: ManagementEmailsEditScene,
	},
}

const ManagementEmailsNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementEmailsNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementEmailsNavigator
